import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import { Row, Col, Switch } from 'antd'
import RootState from 'typings/RootState'
import { DropdownList } from 'Components/Shared/Form'
import { CloseIcon } from 'Components/Shared/Icon'
import PrimaryButton from 'Components/Shared/Button/PrimaryButton'
import { InputNumber, InputText } from 'Components/Shared/Input'
import {
  ChecklistSVCountTypeDetail,
  ChecklistTypeConfigListDetail,
} from 'features/admin/checklist-config/types'
import { max } from 'lodash'
import CheckAsOptions from 'Components/Shared/Filters/CheckAsOptions'

type Props = ReduxProps &
  DispatchProps & {
    countTypeList: ChecklistSVCountTypeDetail[]
    item: ChecklistTypeConfigListDetail
    onSave?: (item: any) => void
    onClose: () => void
    isUpdateMode?: boolean
  }

const ChecklistConfigDetail: React.ComponentType<Props> = props => {
  const { item, isUpdateMode = false, countTypeList } = props
  const [dataItem, setdataItem] = useState({} as any)
  const [countTypeItem, setCountType] = useState([] as any)

  const dispatch = useDispatch()

  useEffect(() => {
    setdataItem(item)
  }, [item])

  useEffect(() => {
    countTypeList.map(item => {
      countTypeItem.push({
        name: item.CountTypeSVDescription,
        value: item.ID,
      })
    })
  }, [countTypeList])

  const status = [
    {
      name: 'เปิดใช้งาน',
      value: 'A',
    },
    {
      name: 'ปิดใช้งาน',
      value: 'N',
    },
  ]

  const onSave = () => {
    if (props.onSave) {
      props.onSave(dataItem)
    }
  }

  return (
    <MainPage>
      <Header>
        <CloseIcon color="#8b99a7" size={24} onClick={props.onClose} />
      </Header>
      <Row>
        <Col span={24}>
          <Title>ประเภท Checklist Site Visit</Title>
        </Col>
        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="ชื่อ Checklist"
              value={dataItem.ChecklistName}
              onChange={(val: string) => {
                dataItem.ChecklistName = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุชื่อ Checklist"
            />
          </BodyArea>
        </Col>

        <Col span={24}>
          <BodyArea>
            <InputNumber
              prefix="ลำดับ"
              placeholder="ระบุ ลำดับ"
              value={dataItem.Sequence}
              onChange={(val: number) => {
                dataItem.Sequence = Number(val)
                setdataItem({ ...dataItem })
              }}
            />
          </BodyArea>
        </Col>

        <Col span={24}>
          <BodyArea>
            <DropdownList
              label="ประเภทการนับ"
              value={dataItem.CountTypeSV_ID}
              menu={countTypeItem}
              onChange={(val: string) => {
                dataItem.CountTypeSV_ID = val
                setdataItem({ ...dataItem })
              }}
            />
          </BodyArea>
        </Col>

        {isUpdateMode == true && (
          <Col span={24}>
            {/* <SwitchArea>
              <Switch
                checked={item.IsActive == 'A'}
                onChange={() => {
                  item.IsActive = item.IsActive === 'A' ? 'N' : 'A'
                  setdataItem({ ...dataItem })
                }}
                disabled={false}
              />
            </SwitchArea> */}

            <BodyArea>
              <DropdownList
                label="สถานะการใช้งาน"
                value={dataItem.IsActive}
                menu={status}
                onChange={(val: string) => {
                  dataItem.IsActive = val
                  setdataItem({ ...dataItem })
                }}
              />
            </BodyArea>
          </Col>
        )}

        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="Remark"
              value={dataItem.Remark}
              onChange={(val: string) => {
                dataItem.Remark = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุ Remark"
            />
          </BodyArea>
        </Col>

        <Col span={24}>
          <SwitchArea>
            <Row type="flex" justify="space-between" align="middle">
              <Col>
                {' '}
                <Text>แสดงผลคะแนน</Text>
              </Col>
              <Col>
                {' '}
                <Switch
                  checked={dataItem.IsDisplayScore}
                  defaultChecked={dataItem.IsDisplayScore}
                  onChange={() => {
                    dataItem.IsDisplayScore = !dataItem.IsDisplayScore
                    setdataItem({ ...dataItem })
                  }}
                  disabled={false}
                />
              </Col>
            </Row>
          </SwitchArea>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <SaveArea>
          <PrimaryButton onClick={onSave} text="บันทึก" />
        </SaveArea>
      </Row>
    </MainPage> //IsDisplayScore
  )
}

const MainPage = styled.div`
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow-x: scroll;
`

const Header = styled.div`
  text-align: right;
  height: 40px;

  svg {
    cursor: pointer;
  }
`

const Title = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 28px;
  margin-bottom: 14px;
`

const Text = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 20px;
`

const SaveArea = styled.div`
  margin-top: 32px;
  float: right;
  width: 160px;
`

const BodyArea = styled.div`
  font-family: 'DB Helvethaica X 55 Regular';
  span {
    font-size: 20px;
  }
  .ant-dropdown-trigger {
    margin-bottom: 12px;
  }
  .input-title {
    margin-bottom: 12px;
  }
`

const SwitchArea = styled.div`
  padding: 0 10px;
  float: left;
  width: 100%;
`

const mapStateToProps = (state: RootState) => {
  return {}
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChecklistConfigDetail)
